import React from 'react';
import { Box, Paper } from '@mui/material';
import ContentLoader from 'react-content-loader';

const SkeletonChecklist = () => (
  <Box sx={{ p: 2 }}>
    {[...Array(3)].map((_, idx) => (
      <Paper key={idx} elevation={2} sx={{ mb: 2, p: 1, borderRadius: '4px' }}>
        <ContentLoader
          speed={2}
          width="100%"
          height={100}
          backgroundColor="#3D393B"
          foregroundColor="#4A494B"
        >
          {/* Checklist title and actions */}
          <rect x="0" y="10" rx="5" ry="5" width="80%" height="20" />
          <rect x="90%" y="10" rx="5" ry="5" width="20" height="20" />

          {/* Checklist progress */}
          <rect x="0" y="40" rx="5" ry="5" width="50%" height="10" />
          <rect x="0" y="60" rx="5" ry="5" width="100%" height="10" />

          {/* Checklist items */}
          <rect x="0" y="80" rx="5" ry="5" width="90%" height="20" />
          <rect x="0" y="110" rx="5" ry="5" width="70%" height="20" />
        </ContentLoader>
      </Paper>
    ))}
  </Box>
);

export default SkeletonChecklist;
